import * as React from "react";

function SvgLogoNoSlogonBlack(props) {
    const { width, height, fill, style } = props
    return (
        <svg
            xmlns ="http://www.w3.org/2000/svg"
            id="logoNoSlogonBlack_svg__svg130"
            preserveAspectRatio="slice"
            height={height}
            width={width}
            viewBox="-15 -10 93.415 40"
            {...props}
        >
            <style id="style4" />
          
            <g
                transform="translate(0 -20)"
                id="logoNoSlogonBlack_svg__g128"
                opacity={1}
            >
                <svg
                    id="logoNoSlogonBlack_svg__svg126"
                    viewBox="0 0 93.415 100"
                    preserveAspectRatio="slice"
                    y={0}
                    x={0}
                    height={height}
                    width={width}
                    {...props}
                >
                    <g
                        transform="translate(0 0)"
                        id="logoNoSlogonBlack_svg__g124"
                        fill="#f1ec40"
                        fillOpacity={1}
                    >
                        <g id="logoNoSlogonBlack_svg__g122">
                            <g id="logoNoSlogonBlack_svg__g114">
                                <path
                                    transform="matrix(.0327 0 0 .0327 -29.945 20.985)"
                                    d="M2255.793-94.967c-64.75 0-117.233 52.453-117.233 117.264 0 64.688 52.484 117.174 117.233 117.174h408.377l129.469 153.691-511.848 483.77c-11.898 8.074-23.123 17.342-33.37 28.138-75.729 80.042-72.272 206.42 7.74 282.12l396.876 375.558-515.09 123.473c-63.8 15.262-103.134 79.431-87.81 143.232 15.292 63.801 79.37 103.133 143.2 87.78l727.415-174.276c13.58-3.303 27.158-9.115 39.3-17.465 53.892-36.947 67.626-110.597 30.71-164.488l-7.371-10.766-300.442-438.228 429.48-301.51 99.22 238.75c18.228 43.768 60.864 72.242 108.302 72.242h436.547c64.75 0 117.203-52.515 117.203-117.234s-52.454-117.295-117.203-117.295h-358.37L3289.888 526.59c-4.558-11.072-10.829-21.44-18.567-30.555l-7.248-8.564-242.144-287.381-213.578-253.4a117.11 117.11 0 00-89.616-41.657h-462.941zm1256.174 74.2c-135.127 0-244.653 109.525-244.653 244.652 0 135.004 109.526 244.531 244.653 244.531 135.004 0 244.531-109.527 244.531-244.531 0-135.127-109.527-244.653-244.531-244.653zM1646.379 348.001c-40.954 0-74.107 33.154-74.107 74.139 0 40.923 33.153 74.078 74.107 74.078h604.186c40.953 0 74.076-33.155 74.076-74.078 0-40.985-33.123-74.139-74.108-74.139H1646.38zM1368.54 625.869c-40.954 0-74.107 33.125-74.107 74.11 0 40.923 33.153 74.078 74.107 74.078h604.154c40.954 0 74.108-33.155 74.108-74.078 0-40.985-33.154-74.14-74.108-74.11h-604.154zm-277.867 277.809c-40.954 0-74.11 33.153-74.11 74.168 0 40.923 33.187 74.078 74.11 74.078h604.183c40.954 0 74.11-33.155 74.11-74.078 0-41.015-33.187-74.168-74.14-74.168h-604.153zm960.504 68.142L1267.12 1644.64c-51.261 44.165-59.825 121.485-17.893 175.56 43.31 55.94 123.717 66.157 179.627 22.848l779.012-602.87-50.894-48.202c-61.752-58.48-98.669-136.075-105.795-220.155z"
                                    id="logoNoSlogonBlack_svg__path108"
                                    fill={fill}
                                    fillOpacity={1}
                                    strokeWidth={30.585}
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            </g>
        </svg>
    );
}

export default SvgLogoNoSlogonBlack;